import { resolveUserMessage } from "./getErrorMessage";
import type { AppError, AppErrorKind } from "./types";

/**
 * Creates a new AppError instance.
 * @param kind The category of the error, which can be used to determine how to handle and display the error.
 * @param message The error message.
 * @param cause The underlying cause of the error.
 * @param overrides Optional overrides for the error properties.
 * @returns The created AppError instance.
 */
export function createAppError(kind: AppErrorKind, message: string, cause: unknown, overrides: Partial<AppError> = {}): AppError {
  
  const appError: AppError = {
    name: "AppError",
    kind,
    message,
    userMessage: "",
    retryable: false,
    defaultDisplayMode: "toast",
    logLevel: kind === "server" || kind === "unexpected" ? "error" : "warn",
    cause,
    ...overrides,
  };

  appError.userMessage = resolveUserMessage(appError);

  return appError;
}
